import { render, staticRenderFns } from "./BsBadge.vue?vue&type=template&id=54f0f95f&"
import script from "./BsBadge.vue?vue&type=script&lang=js&"
export * from "./BsBadge.vue?vue&type=script&lang=js&"
import style0 from "./BsBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports